module.exports = __webpack_public_path__ + "static/media/exampleImage.e4e6570b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/exampleImage.png
// module id = 284
// module chunks = 0